import axios from 'axios';
import { LIONDESK_EMAIL_ACCOUNT } from './../config/email-account-types';

const lionDeskEmailAccount = {
  id: 0,
  email: '',
  // LionDesk email account means that the email will be send via sendgrid
  name: LIONDESK_EMAIL_ACCOUNT,
  feature_ids: [],
};

export default {
  namespaced: true,
  state: {
    error: '',
    selectedEmailAccount: null,
    allowedNewFlow: false,
  },
  getters: {
    emailAccounts: (state, getters, rootState) => {
      return [lionDeskEmailAccount, ...rootState.emailManagement.emailAccounts];
    },
  },
  mutations: {
    setSelectedEmailAccount(state, emailAccount) {
      state.selectedEmailAccount = emailAccount;
    },
    setError(state, error) {
      state.error = error;
    },
    setAllowedNewFlow(state, allowed) {
      state.allowedNewFlow = allowed;
    },
  },
  actions: {
    setSelectedEmailAccount({ commit }, emailAccount) {
      commit('setSelectedEmailAccount', emailAccount);
    },
    resetSelectedEmailAccount({ commit }) {
      commit('setSelectedEmailAccount', null);
    },
    async getAllowedNewFlow({ commit }) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/email/allowed/new-flow`);

        commit('setAllowedNewFlow', response.data.allowed);
      } catch (error) {
        commit('setAllowedNewFlow', false);
      }
    },
  },
};
